module.exports = __webpack_public_path__ + "static/media/risk.c010e10a.svg";